import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * BuiltOS typographic wordmark — Montserrat 700 in navy with a small raised
 * steel-blue mark. Used on the public landing / onboarding pages.
 */
export const Wordmark = ({ className, size = "md", to = "/", as: asProp, ...rest }) => {
  const text = size === "lg" ? "text-[26px]" : size === "sm" ? "text-[16px]" : "text-[20px]";
  const mark = size === "lg" ? "h-2.5 w-2.5" : "h-2 w-2";
  const inner = (
    <span className={cn("inline-flex items-start font-heading font-bold tracking-[-0.02em] text-primary", text)}>
      Built<span className="text-[hsl(var(--chart-net))]">OS</span>
      <span aria-hidden="true" className={cn("ml-1 mt-1 inline-block rotate-45 rounded-[2px] bg-[hsl(var(--chart-net))]", mark)} />
    </span>
  );
  if (asProp === "span") {
    return (
      <span className={cn("inline-flex items-center", className)} {...rest}>
        {inner}
      </span>
    );
  }
  return (
    <Link
      to={to}
      aria-label="BuiltOS home"
      className={cn("inline-flex items-center rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2", className)}
      {...rest}
    >
      {inner}
    </Link>
  );
};
